import dynamic from "next/dynamic";

const DynamicCardDetailsDialog = dynamic(
  () => import("modules/common/components/CardDetailsDialog/CardDetailsModal"),
  {
    loading: () => <></>,
  }
);

export default DynamicCardDetailsDialog;
